export const LOGIN = "AUTH@LOGIN";
export const LOGIN_INIT = "AUTH@LOGIN_INIT";
export const LOGIN_SUCCESS = "AUTH@LOGIN_SUCCESS";
export const LOGIN_FAILED = "AUTH@LOGIN_FAILED";

export const TWO_FACTOR_AUTH = "AUTH@TWO_FACTOR_AUTH";
export const TWO_FACTOR_AUTH_INIT = "AUTH@TWO_FACTOR_AUTH_INIT";
export const TWO_FACTOR_AUTH_SUCCESS = "AUTH@TWO_FACTOR_AUTH_SUCCESS";
export const TWO_FACTOR_AUTH_FAILED = "AUTH@TWO_FACTOR_AUTH_FAILED";

export const VERIFY_PHONE = "AUTH@VERIFY_PHONE";
export const VERIFY_PHONE_INIT = "AUTH@VERIFY_PHONE_INIT";
export const VERIFY_PHONE_SUCCESS = "AUTH@VERIFY_PHONE_SUCCESS";
export const VERIFY_PHONE_FAILED = "AUTH@VERIFY_PHONE_FAILED";

export const TERMS_AND_CONDITION = "AUTH@TERMS_AND_CONDITION";
export const TERMS_AND_CONDITION_INIT = "AUTH@TERMS_AND_CONDITION_INIT";
export const TERMS_AND_CONDITION_SUCCESS = "AUTH@TERMS_AND_CONDITION_SUCCESS";
export const TERMS_AND_CONDITION_FAILED = "AUTH@TERMS_AND_CONDITION_FAILED";

export const SEND_TWO_FA_CODE = "AUTH@SEND_TWO_FA_CODE";
export const SEND_TWO_FA_CODE_INIT = "AUTH@SEND_TWO_FA_CODE_INIT";
export const SEND_TWO_FA_CODE_SUCCESS = "AUTH@SEND_TWO_FA_CODE_SUCCESS";
export const SEND_TWO_FA_CODE_FAILED = "AUTH@SEND_TWO_FA_CODE_FAILED";

export const SEND_TWO_FA_CODE_TO_EMAIL = "AUTH@SEND_TWO_FA_CODE_TO_EMAIL";
export const SEND_TWO_FA_CODE_TO_EMAIL_INIT = "AUTH@SEND_TWO_FA_CODE_TO_EMAIL_INIT";
export const SEND_TWO_FA_CODE_TO_EMAIL_SUCCESS = "AUTH@SEND_TWO_FA_CODE_TO_EMAIL_SUCCESS";
export const SEND_TWO_FA_CODE_TO_EMAIL_FAILED = "AUTH@SEND_TWO_FA_CODE_TO_EMAIL_FAILED";